import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-study-link',
    templateUrl: './study-link.component.html',
    styleUrls: ['./study-link.component.scss'],
    standalone: false
})
export class StudyLinkComponent {
  @Output() fileClick = new EventEmitter<any>();
  @Input() element: any;
  @Input() dicomdirFileName: string = '';
  handleFileClick($event: MouseEvent, arg1: any) {
    console.log('Clicked', $event, arg1);
    this.fileClick.emit({ $event, arg1 });
  }

  constructor() {}
}
